require('./ctxSelect.style.scss');
require('../../sharedStyles/ctxInputTooltip.style.scss');
const DEFAULT_START = 0,
    DEFAULT_COUNT = 30,
    HIDDEN_COUNT = 10,
    SCROLLING_STEPS = 10,
    DEFAULT_HEIGHT = 30;
let RANG_FIRST, RANG_LAST, PARTIAL_RENDER;

class CtxSelectController {
    constructor($scope, $element, $attrs, $timeout, sharedHelperService) {
        this.$scope = $scope;
        this.$element = $element;
        this.$timeout = $timeout;
        this.selectValue = '';
        this.selectName = $attrs.name;
        this.tooltipUpDown = 'up';
        this.index = -1;
        $timeout(() => this.id = $attrs.eventId, 0);
        this.isIE = sharedHelperService.checkIfIE();
        this.multiple = !angular.isUndefined($attrs.multiple) && $attrs.multiple !== 'false';
        this.tooltipPosition = this.tooltipPosition || 'right';
        this.selectedItems = [];
        this.customSearchId = "select-search";
        this.uniqueDropdown = "dropdown-unique-" + Math.floor(Math.random() * 1000);
    }

    $onInit() {
        this.ngModel.$render = () => {
            this.$timeout(() => {
                this.selectValue = this.ngModel.$viewValue;
                if (this.optionList) {
                    this.clickableItems = this.optionsList.filter(item => !item.disabled);
                }
            }, 0);
        };
        this.itemHeight = DEFAULT_HEIGHT;
        this.dropdown = false;
        this.dropdownJQ = this.$element.find('.ctx-select-content');

        this.dropdownJQ.focusout((e) => {
            if (!e.relatedTarget || (!this.searchFn || e.relatedTarget.id !== 'select-search')) { // added condition for search input because focusout is triggered when search input is focused
                if (!this.stillHasFocus && (!e.relatedTarget || (e.relatedTarget && (e.relatedTarget.classList[0] !== 'ctx-select-content' || e.relatedTarget.classList[1] !== this.uniqueDropdown)))) {
                    this.ngModel.$setTouched(true);
                    this.dropdown = false;
                    this.$element.find('.dropdown').css('display', 'none');
                    this.index = -1;
                } else {
                    // custom scrollbar directive somehow steals focus
                    // has to return focus so it continues working as intended
                    this.recoverFocus();
                }
                this.stillHasFocus = false;
            }
        });

        //SINGLESELECT KEY COMMANDS
        if (!this.multiple) {
            this.dropdownJQ.keydown((arg) => {
                if (!this.isDisabled) {
                    switch (arg.keyCode) {
                        case 38: // UP ARROW
                            arg.preventDefault();
                            arg.stopPropagation();
                            for (let i = this.index - 1; i >= 0; i--) {
                                if (!this.optionsList[i].disabled) {
                                    this.selectAction(this.index = i);
                                    break;
                                }
                            }
                            break;
                        case 40: // DOWN ARROW
                            arg.preventDefault();
                            arg.stopPropagation();
                            if (!this.dropdown) this.toggleDropdown();
                            for (let i = this.index + 1; i < this.optionsList.length; i++) {
                                if (!this.optionsList[i].disabled) {
                                    this.selectAction(this.index = i);
                                    break;
                                }
                            }
                            break;
                        case 13: //ENTER
                            arg.preventDefault();
                            arg.stopPropagation();
                            this.toggleDropdown();
                            break;
                    }
                }
            });
        } else {
            this.$timeout(() => {
                if (this.optionsList) {
                    this.optionsList.forEach((elem) => {
                        delete elem.selected;
                    });
                }

                if (this.ngModel.$viewValue && this.ngModel.$viewValue.length > 0) {
                    this.ngModel.$viewValue.forEach((elem) => {
                        _.find(this.optionsList, option => option.value === elem.value).selected = true;
                    });
                }
            }, 0);

            //MULTISELECT KEY COMMANDS
            this.dropdownJQ.keydown((arg) => {
                if (!this.isDisabled) {
                    switch (arg.keyCode) {
                        case 32: //SPACE
                            arg.preventDefault();
                            this.selectAction(this.index);
                            break;
                        case 38: // UP ARROW
                            arg.preventDefault();
                            for (let i = this.index - 1; i >= 0; i--) {
                                if (!this.optionsList[i].disabled) {
                                    this.hoverSelection(this.index = i);
                                    break;
                                }
                            }
                            break;
                        case 40: // DOWN ARROW
                            arg.preventDefault();
                            if (!this.dropdown) this.toggleDropdown();
                            for (let i = this.index + 1; i < this.optionsList.length; i++) {
                                if (!this.optionsList[i].disabled) {
                                    this.hoverSelection(this.index = i);
                                    break;
                                }
                            }
                            break;
                        case 13: //ENTER
                            arg.preventDefault();
                            this.toggleDropdown();
                            break;
                        case 27: //ESCAPE
                            arg.preventDefault();
                            this.clearAll();
                            break;
                    }

                    //CTRL + A select all
                    if (arg.keyCode == 65 && arg.ctrlKey) this.toggleSelectAll();
                }
            });
        }

        this.$scope.$watchCollection(() => this.optionsList, () => {
            this.availableSteps = this.setVisibleRenderIndex(this.optionsList, 0);  // not depending on partial render property
            if (this.partialRender) {
                if (!this.optionsContainer || !this.optionsContainer[0] || !this.scrollableContainer) {
                    RANG_FIRST = DEFAULT_START;
                    RANG_LAST = DEFAULT_COUNT;
                } else {
                    this.disableScroll();
                    this.$timeout(() => {
                        this.setDefaultRangValue();
                        this.setScrollableContainerHeight();
                        this.$timeout(() => this.enableScroll(), 0);
                    }, 0);
                }
            }
        });
        PARTIAL_RENDER = this.partialRender;
    }

    toggleDropdown() {
        PARTIAL_RENDER = this.partialRender;
        if (this.scrollTo && !this.dropdown) {
            this.scrollTo();
        }
        if (this.index !== -1 && (!this.optionsList[this.index] || this.optionsList[this.index].disabled)) {
            this.index = -1;
        }
        this.dropdown = !this.dropdown;
        if (this.dropdown) {
            this.noAvailableItem = this.optionsList.length === this.optionsList.filter(item => item.disabled).length;
            this.$element.find('.scroll-wrapper').addClass("opened-dropdown");
        } else {
            this.index = -1;
            this.$element.find('.scroll-wrapper').removeClass("opened-dropdown");
        }
        this.$element.find('.dropdown').css('display', this.dropdown ? 'block' : 'none');

        this.clickableItems = this.optionsList.filter(item => !item.disabled);
        if (this.partialRender) this.setDefaultRangValue();
        if (this.searchFn) {
            if (this.dropdown) {
                if (!!this.isIE) this.$element.find('input').focus();
                else this.$timeout(() => this.$element.find('input').focus(), 0);
            }
            if (this.ngModel.$viewValue) this.customPlaceHolder = this.ngModel.$viewValue.label;
        }
        if (this.originalList) {
            this.selectedItems = this.originalList.filter(item => item.selected);
        } else {
            this.selectedItems = this.optionsList.filter(item => item.selected);
        }
    }

    selectionTriggered(index) {
        if (!this.optionsList[index].disabled) {
            if (!this.multiple) {
                this.toggleDropdown();
            }
            this.selectAction(index);
        }
    }

    hoverSelection(index, direction) {
        this.ngModel.$setViewValue(this.selectedItems);
        this.ngModel.$render();
        this.scrollElementIntoView();
    }

    selectAction(index) {
        if (this.multiple) {
            let optionItem = this.optionsList[index];
            if (optionItem.selected) {
                optionItem.selected = false;
                if (this.originalList) this.originalList[optionItem.id].selected = false;
                this.selectedItems = this.selectedItems.filter(obj => {
                    return obj.value !== optionItem.value;
                });
            } else {
                optionItem.selected = true;
                if (this.originalList) this.originalList[optionItem.id].selected = true;
                if (this.selectedItems.filter(item => item.value === optionItem.value).length === 0) this.selectedItems.push(optionItem);
            }
            this.ngModel.$setViewValue(this.selectedItems);
            this.ngModel.$render();
        } else {
            if (angular.isDefined(this.selectDefault) && this.selectDefault !== false) {
                this.selectDefault.isSelected = false;
            }
            if (index > -1 && index < this.optionsList.length) {
                this.ngModel.$setViewValue(this.optionsList[index]);
                this.ngModel.$render();
                this.scrollElementIntoView();
            }
        }
    }

    scrollElementIntoView() {
        this.$timeout(() => {
            var element = document.getElementsByClassName("option-highlight")[0];
            var container = document.getElementsByClassName('opened-dropdown')[0];
            if (element && container) {
                var rectElem = element.getBoundingClientRect(), rectContainer = container.getBoundingClientRect();

                if (rectElem.bottom > rectContainer.bottom) element.scrollIntoView(false);
                if (rectElem.top < rectContainer.top) element.scrollIntoView();
            }
        }, 50);
    }

    mouseover(index) {
        if (index === -1) {
            this.index = -1;
            return;
        }
        if (!this.optionsList[index].disabled) {
            this.index = index;
        }
    }

    toggleSelectAll($event) {
        let isAllSelected = this.optionsList.filter(item => item.selected === true && !item.disabled).length !== this.optionsList.filter(item => !item.disabled).length;
        if (isAllSelected) {
            this.optionsList.forEach(item => {
                if (!item.disabled) {
                    item.selected = true;
                    if (this.selectedItems.filter(si => si.value === item.value).length === 0) this.selectedItems.push(item);
                }
            });
            if (this.originalList) {
                this.originalList.forEach(item => {
                    if (this.optionsList.map(ol => ol.id).indexOf(item.id) !== -1 && !item.disabled) {
                        item.selected = true;
                    }
                });
            }
            this.ngModel.$setViewValue(this.selectedItems);
            this.ngModel.$render();
            this.stillHasFocus = false;
        } else {
            this.clearAll($event);
        }
    }

    setDefault() {
        this.selectDefault.isSelected = true;
        this.toggleDropdown();
        this.ngModel.$setViewValue(this.selectDefault);
        this.ngModel.$render();
    }

    clearAll($event) {
        this.optionsList.forEach((item) => { if (!item.disabled) { item.selected = false; } });
        if (this.originalList) this.originalList.forEach((item) => { if (!item.disabled) { item.selected = false; } });
        if ($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        this.selectedItems = this.optionsList.filter(item => item.selected);
        this.ngModel.$setViewValue(this.selectedItems);
        this.ngModel.$render();
        if (this.onClear) {
            this.onClear();
        }
    }

    recoverFocus() {
        this.$element.find('.ctx-select-content').focus();
    }


    /** PARTIAL RENDER: START */
    setVisibleRenderIndex(items, step) {
        if (!items || !items.length) return;
        items.forEach(i => {
            i.visibleIndex = step;
            step++;
        });
        return step;
    }

    setDefaultRangValue() {
        RANG_FIRST = DEFAULT_START;
        RANG_LAST = DEFAULT_COUNT;
        this.topNotDisplayed = 0;
        if (this.scrollableContainer && this.scrollableContainer[0]) this.scrollableContainer.css({ top: '0px' });
        this.previous_mCSC_Top = 0;
    }

    updateValues() {
        if (!!this.isIE) {
            return this.update();
        }
        this.$timeout(() => this.update(), 0);
    }

    update() {
        let top = Math.abs(this.scrollableContainer.position().top),
            topRowsCount = this.itemHeight ? Math.floor(top / this.itemHeight) : 0,
            temp = topRowsCount - HIDDEN_COUNT;

        RANG_FIRST = Number.isFinite(temp) && temp >= 0 ? temp : 0;
        RANG_LAST = RANG_FIRST + DEFAULT_COUNT;
        if (!Number.isFinite(temp)) {
            top = 0;
            this.scrollableContainer.css({ top: top + 'px' });
        }
        this.topNotDisplayed = RANG_FIRST * this.itemHeight;
        this.previous_mCSC_Top = top;
        this.previous_mCSC_Height = this.availableSteps * this.itemHeight;
    }

    enableScroll() {
        this.optionsContainer.mCustomScrollbar("update");
        this.waitToReset = false;
    }

    disableScroll() {
        this.waitToReset = true;
        this.optionsContainer.mCustomScrollbar("disable", true);
    }

    customOptionsFilter(item) {
        return !PARTIAL_RENDER || (item.visibleIndex >= RANG_FIRST && item.visibleIndex <= RANG_LAST);
    }

    checkDomVisibility(visibleIndex) {
        return visibleIndex >= RANG_FIRST && visibleIndex <= RANG_LAST;
    }
    /** PARTIAL RENDER: END */

    haveMultipleSelectedValues() {
        return this.multiple && this.selectValue && this.selectValue.length;
    }

    disableSelectAll() {
        return this.optionsList && (this.optionsList.length === this.optionsList.filter(item => item.disabled).length);
    }

    searchValue() {
        this.searchFn();
        this.$scope.$apply();
        this.clickableItems = this.optionsList.filter(item => !item.disabled);
        this.index = -1;
    }

    addItem() {
        this.addNewAction();
    }
}

const ctxSelectComponent = {
    restrict: 'E',
    controller: CtxSelectController,
    scope: {},
    require: {
        ngModel: 'ngModel'
    },
    template: require('./ctxSelect.template.html'),
    bindings: {
        isDisabled: '<?',
        form: '<',
        selectLabel: '@?',
        // inputClass: '@?',
        optionsList: '=?',
        originalList: '=?',
        requiredMessage: '@?',
        textMessageShow: '<?',
        customPlaceholder: '@?',
        tooltipPosition: '@?',
        tooltipUpDown: '@?',
        showPopup: '<?',
        customScrollBar: '<?',
        showClear: '<?',
        showAddItem: '<?',
        iconTooltip: '@',
        iconTooltipText: '@',
        scrollTo: '&?',
        selectDefault: '=?',
        searchFn: '&?',
        hasSearchBox: '<?',
        tableState: '=?',
        textMessage: '@?',
        showMessage: '<?',
        partialRender: '<?',
        disabledWarningMessage: '@?',
        addNewAction: '&?',
        onClear: '&?'
    }
};

CtxSelectController.$inject = ['$scope', '$element', '$attrs', '$timeout', 'sharedHelperService'];

module.exports = ctxSelectComponent;



// WEBPACK FOOTER //
// ./src/shared/ctxSelect/ctxSelect.component.js